import { render, staticRenderFns } from "./myGiftAll.vue?vue&type=template&id=389a6ea0&scoped=true"
import script from "./myGiftAll.vue?vue&type=script&lang=js"
export * from "./myGiftAll.vue?vue&type=script&lang=js"
import style0 from "./myGiftAll.vue?vue&type=style&index=0&id=389a6ea0&prod&lang=scss"
import style1 from "./myGiftAll.vue?vue&type=style&index=1&id=389a6ea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389a6ea0",
  null
  
)

export default component.exports